class AudioService {
  constructor() {
    this.audioContext = null
    this.soundsEnabled = true
    this.volume = 0.7
  }

  async ensureAudioContext() {
    if (!this.audioContext && typeof window !== 'undefined') {
      try {
        this.audioContext = new (window.AudioContext || window.webkitAudioContext)()
      } catch (error) {
        return
      }
    }
    if (this.audioContext && this.audioContext.state === 'suspended') {
      await this.audioContext.resume()
    }
  }

  async playAttentionAlert() {
    if (!this.soundsEnabled) return
    try {
      await this.ensureAudioContext()
      if (!this.audioContext) return
      await this.playBeep(800, 0.15, 'sine')
      setTimeout(async () => {
        await this.playBeep(600, 0.15, 'sine')
      }, 200)
    } catch (error) {
      // Ignore
    }
  }

  async playMessageAlert() {
    if (!this.soundsEnabled) return
    try {
      await this.ensureAudioContext()
      if (!this.audioContext) return
      await this.playBeep(400, 0.1, 'sine')
    } catch (error) {
      // Ignore
    }
  }

  async playSuccessSound() {
    if (!this.soundsEnabled) return
    try {
      await this.ensureAudioContext()
      if (!this.audioContext) return
      await this.playBeep(523, 0.1, 'sine')
      setTimeout(async () => {
        await this.playBeep(659, 0.1, 'sine')
      }, 100)
      setTimeout(async () => {
        await this.playBeep(784, 0.15, 'sine')
      }, 200)
    } catch (error) {
      // Ignore
    }
  }

  async playBeep(frequency = 440, duration = 0.2, type = 'sine') {
    if (!this.audioContext) return

    const oscillator = this.audioContext.createOscillator()
    const gainNode = this.audioContext.createGain()

    oscillator.connect(gainNode)
    gainNode.connect(this.audioContext.destination)

    oscillator.frequency.setValueAtTime(frequency, this.audioContext.currentTime)
    oscillator.type = type

    gainNode.gain.setValueAtTime(0, this.audioContext.currentTime)
    gainNode.gain.linearRampToValueAtTime(this.volume, this.audioContext.currentTime + 0.01)
    gainNode.gain.exponentialRampToValueAtTime(0.01, this.audioContext.currentTime + duration)

    oscillator.start(this.audioContext.currentTime)
    oscillator.stop(this.audioContext.currentTime + duration)

    return new Promise(resolve => {
      oscillator.onended = resolve
    })
  }

  setSoundsEnabled(enabled) {
    this.soundsEnabled = enabled
  }

  setVolume(volume) {
    this.volume = Math.max(0, Math.min(1, volume))
  }

  isSupported() {
    return !!(window.AudioContext || window.webkitAudioContext)
  }

  async requestAudioPermission() {
    try {
      await this.ensureAudioContext()
      await this.playBeep(440, 0.01, 'sine')
      return true
    } catch (error) {
      return false
    }
  }
}

const audioService = new AudioService()
export default audioService
